import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../Auths/CheckUser";
import { AirRoutes } from "./AirRouter";
import { SewaRoutes } from "./SewaRouter";
import Login from "../pages/Login";

const AppRouter = () => {
  const { user } = useAuth();

  const isLoggedIn = !!localStorage.getItem("admin-mobile-token");
  const type = user?.type || "sewa";

  return (
    <Routes>
      <Route
        path="/login"
        element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <Login />}
      />

      {type === "air" ? AirRoutes : SewaRoutes}

      <Route
        path="*"
        element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />}
      />
    </Routes>
  );
};

export default AppRouter;